// @flow
import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { ArrowLeft } from '@finect/tabular-icons/arrowLeft';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { NavRevealConsumer } from './Navigation';

const NavBack = styled.a`
  position: relative;
  flex-shrink: 0;
  padding: 18px 30px 18px 28px;

  margin-right: 15px;
  color: ${({ theme }) => theme.colors.font};

  &:after {
    position: absolute;
    top: 18px;
    bottom: 18px;
    right: 0;
    border-right: 1px solid ${({ theme }) => theme.borderColor};
    content: '';
  }

  &:hover {
    color: ${({ theme }) => theme.mainColor};
  }

  svg {
    position: absolute;
    top: 17px;
    left: -2px;
  }
`;

const NavHeader = styled.div`
  ${({ reveal }) => reveal && 'display: none;'};
  position: fixed;
  z-index: 30;
  top: 0px;
  border-top: 6px solid ${({ styles }) => (styles ? styles.background : '#fff')};

  transform: translateY(${props => (props.omniNavState === 'opened' ? props.theme.navHeight - 6 : 0)}px);

  ${maxMediaQueries.phone`
    transform: translateY(${props => (props.omniNavState === 'opened' ? props.theme.mobileNavHeight - 6 : 0)}px);
  `};

  transition: transform 0.25s cubic-bezier(0.49, 0.42, 0.52, 0.98);

  left: 0;
  right: 0;
  box-shadow: 0 15px 35px rgb(34 34 90 / 0.07), 0 5px 15px rgb(0 0 0 / 0.05), 0 1px 3px 1px rgb(34 34 90 / 0.05);
  background-color: ${({ styles }) => (styles ? styles.background : '#fff')};
  color: ${({ styles }) => (styles ? styles.color : 'currentColor')};
  backface-visibility: hidden;

  ${({ styles }) =>
    styles &&
    `
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    `};

  h1 {
    ${getFont(2)};
    font-weight: 600;

    ${maxMediaQueries.tablet`
      ${getFont(1, 'xcompact')};
    `};
  }
`;

const centeredStyled = css`
  ${getFont(-1, 'compact')};
  font-weight: 600;
  text-align: center;
`;

const NavHeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ centered }) => (centered ? 'center' : 'space-between')};
  max-width: ${({ theme }) => theme.maxWidth};
  height: 60px;
  padding: 0 30px;
  margin: 0 auto;

  ${({ centered }) => centered && centeredStyled};

  ${maxMediaQueries.phablet`
    padding: 0 24px;
  `};

  ${maxMediaQueries.phone`
    padding: 0 15px;
  `};
`;

type Props = {
  styles?: Object,
  centered?: boolean,
  omniNavState: string,
  back?: Object,
  children: any
};

export const InsideNavigation = ({ styles, centered, omniNavState, back, children }: Props) => (
  <NavRevealConsumer>
    {({ reveal }) => (
      <NavHeader omniNavState={omniNavState} reveal={reveal} styles={styles}>
        <NavHeaderInner centered={centered}>
          {' '}
          {back ? (
            <NavBack data-fi-event="articleNavigation-back" as={Link} to={back.path}>
              <ArrowLeft size="22" strokeWidth="1.8" />
              {back.title}
            </NavBack>
          ) : null}
          {children}
        </NavHeaderInner>
      </NavHeader>
    )}
  </NavRevealConsumer>
);
